export interface WorkspaceStaff {
  id: string;
  name: string;
  email: string;
  role: WorkspaceUserRole;
  isObserver?: boolean;
}
export class WorkspaceSubscription {
  paymentIntentId: string;
  date: string;
  totalAmount: number;
}

export enum WorkspaceUserRole {
  User = "user",
  Admin = "admin",
  SuperAdmin = "super_admin",
}

export interface CreateWorkspacePayload {
  name: string;
  address: string;
  siren: string;
  owner: {
    name: string;
    email: string;
  };
  subscription: SubscriptionInfo;
}

export interface AddStaffPayload {
  name: string;
  email: string;
  workspaceId: string;
  role: WorkspaceUserRole;
  isObserver?: boolean;
}

export interface UpdateStaffPayload {
  name?: string;
  email?: string;
  role?: WorkspaceUserRole;
  isObserver?: boolean;
}

export interface SubscriptionInfo {
  numberOfTablets: number;
  // annual price
  priceOfPerTablet: number;
  // annual price
  subscriptionDuration: number;
  subscriptionPrice: number;
}


export interface PaymentHistory {
  payments: WorkspaceSubscription[];
  failedPayment?: FailedPayment;
}

export interface FailedPayment {
  date: Date;
  totalAmount: number;
  daysToRenew: number;
}